import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LINKS = [
  { to: "/", label: "HOME", testid: "nav-home-link", end: true },
  { to: "/shop", label: "SHOP MY FAVORITES", testid: "nav-shop-link" },
  { to: "/journey", label: "MY JOURNEY", testid: "nav-journey-link" },
  { to: "/get-started", label: "GET STARTED", testid: "nav-get-started-link" },
  { to: "/merch", label: "MERCH", testid: "nav-merch-link" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const handleContactClick = (e) => {
    if (location.pathname === "/get-started") {
      e.preventDefault();
      const el = document.querySelector("#contact");
      if (el) {
        if (window.__lenis) {
          window.__lenis.scrollTo(el, { offset: -80, duration: 1.6 });
        } else {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }
      setOpen(false);
    }
  };

  const linkClass = ({ isActive }) =>
    `font-display text-xs font-semibold tracking-[0.2em] transition-colors duration-300 hover:text-coral ${
      isActive ? "text-coral" : "text-forest"
    }`;

  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 z-50 w-full border-b border-forest/10 bg-bone/70 px-6 py-4 backdrop-blur-xl transition-all duration-300"
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between">
        <Link to="/" data-testid="nav-brand-link" className="flex items-center gap-3" onClick={() => setOpen(false)}>
          <img src="/logo.png" alt="FitBunnyCat logo" className="h-11 w-11 transition-transform duration-300 hover:scale-105" />
          <span className="font-display text-base font-extrabold tracking-[0.12em] text-forest">FIT BUNNY CAT</span>
        </Link>

        <div className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} data-testid={l.testid} className={linkClass}>
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/get-started#contact"
            data-testid="nav-contact-link"
            onClick={handleContactClick}
            className="rounded-full bg-coral px-5 py-2 font-display text-xs font-semibold tracking-[0.2em] text-bone transition-all duration-300 hover:scale-105 hover:bg-coraldark"
          >
            CONTACT
          </Link>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="text-forest md:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </nav>

      {open && (
        <div data-testid="nav-mobile-menu" className="mt-4 flex flex-col gap-4 border-t border-forest/10 pt-4 md:hidden">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} data-testid={`${l.testid}-mobile`} className={linkClass} onClick={() => setOpen(false)}>
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/get-started#contact"
            data-testid="nav-contact-link-mobile"
            onClick={handleContactClick}
            className="w-fit rounded-full bg-coral px-5 py-2 font-display text-xs font-semibold tracking-[0.2em] text-bone"
          >
            CONTACT
          </Link>
        </div>
      )}
    </header>
  );
};

export default Navbar;
